export const TermsOfService = () => {
  return (
    <div className="min-h-screen pb-20">
      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-10 bg-muted/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            Terms &amp; Conditions
          </h1>
          <p className="text-sm text-muted-foreground">
            Last updated: February 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pt-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Agreement to Terms</h2>
            <p className="text-foreground leading-relaxed">
              By accessing or using Evolution GEO's website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Services</h2>
            <p className="text-foreground leading-relaxed">
              Evolution GEO provides Generative Engine Optimization (GEO), AI Visibility Optimization (AIO), AI advertising management, and AI automation services. The specific scope of services will be defined in individual service agreements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">User Responsibilities</h2>
            <p className="text-foreground leading-relaxed mb-4">
              You agree to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground">
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Use our services in compliance with applicable laws</li>
              <li>Not engage in any activity that interferes with our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Intellectual Property</h2>
            <p className="text-foreground leading-relaxed">
              All content, trademarks, and intellectual property on our website are owned by Evolution GEO or our licensors. You may not use our intellectual property without prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Payment Terms</h2>
            <p className="text-foreground leading-relaxed">
              Services are provided on a subscription or project basis as outlined in your service agreement. Payment terms, refund policies, and cancellation procedures will be specified in individual agreements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Limitation of Liability</h2>
            <p className="text-foreground leading-relaxed">
              Evolution GEO shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with our services. Our total liability shall not exceed the amount paid by you for our services in the 12 months preceding the claim.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Disclaimer</h2>
            <p className="text-foreground leading-relaxed">
              Our services are provided "as is" without warranties of any kind. While we strive to improve your AI visibility, we cannot guarantee specific results or rankings in AI engines.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Modifications</h2>
            <p className="text-foreground leading-relaxed">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective upon posting to our website. Your continued use of our services constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Forms, Communications &amp; Anti‑Bot Protection</h2>
            <p className="text-foreground leading-relaxed mb-4">
              Our Contact form and Free GEO/AIO Audit form are intended for genuine business enquiries and audit requests.
              We use Cloudflare Turnstile on these forms to help protect against bots and abusive submissions. By using these forms,
              you acknowledge that Turnstile may process technical data necessary to verify that you are a real user.
            </p>
            <p className="text-foreground leading-relaxed mb-4">
              By submitting your details through these forms, you authorize Evolution GEO to contact you via email regarding:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground mb-4">
              <li>Responses to your enquiry or your GEO/AIO audit request</li>
              <li>Follow‑up conversations necessary to deliver or clarify our services</li>
              <li>Occasional updates, resources, or offers related to AI visibility and our services</li>
            </ul>
            <p className="text-foreground leading-relaxed">
              You may opt out of marketing communications at any time by following the unsubscribe instructions included in our emails,
              but we may still send you non‑marketing messages related to active or past engagements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Contact Us</h2>
            <p className="text-foreground leading-relaxed">
              If you have questions about these Terms &amp; Conditions, please contact us at:
              <br />
              <a href="mailto:legal@evolutiongeo.com" className="text-primary hover:underline">
                legal@evolutiongeo.com
              </a>
            </p>
          </section>
        </div>
        </div>
      </section>
    </div>
  );
};
